import { LinearProgress } from "@mui/material";
import { useEffect } from "react";
import { app, authentication } from "@microsoft/teams-js";

/**
 * This page is loaded inside the Teams authentication popup after the
 * OAuth flow completes. It initializes the Teams JS SDK and calls
 * `authentication.notifySuccess()` to close the popup and signal
 * the parent iframe that authentication succeeded.
 *
 * For non-Teams contexts (e.g. direct browser navigation), it redirects
 * to the app root.
 */
export function TeamsAuthComplete() {
  useEffect(() => {
    const complete = async () => {
      try {
        await app.initialize();
        authentication.notifySuccess("authenticated");
      } catch {
        // Not running inside a Teams popup — redirect to app root
        window.location.href = "/";
      }
    };

    complete();
  }, []);

  return <LinearProgress />;
}
